import React from 'react';
import CommandList from '../CommandList';

function BingCommand({ onCommandChange, onAddCommand }) {
    const commandItems = [
        { command: 'keyword', description: 'bing_keyword_description', type: 'text' },
        { command: 'OR', description: 'bing_or_description', type: 'hidden', value: 'OR'},
        { command: 'AND', description: 'bing_and_description', type: 'hidden', value: 'AND'},
        { command: '""', description: 'bing_exact_description', type: 'text' },
        { command: '-', description: 'bing_except_description', type: 'text' },
        { command: 'site:', description: 'bing_site_description', type: 'url' },
        { command: 'link:', description: 'bing_link_description', type: 'text'},
        { command: 'filetype:', description: 'bing_filetype_description', type: 'text'},
        { command: 'intitle:', description: 'bing_intitle_description', type: 'text' },
        { command: 'inurl:', description: 'bing_inurl_description', type: 'text' },
        { command: 'intext:', description: 'bing_intext_description', type: 'text' },
        { command: 'contains:', description: 'bing_contains_description', type: 'text' },
        { command: 'ip:', description: 'bing_ip_description', type: 'text' },
        { command: 'loc:', description: 'bing_loc_description', type: 'text' },
        { command: 'language:', description: 'bing_language_description', type: 'text' },
        { command: 'feed:', description: 'bing_feed_description', type: 'text' },
        { command: 'hasfeed:', description: 'bing_hasfeed_description', type: 'text' },
        { command: 'near:', description: 'bing_near_description', type: 'text' }
    ];

    return <CommandList commandItems={commandItems} onCommandChange={onCommandChange} onAddCommand={onAddCommand} />
}

export default BingCommand;
